import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IEscrowJournalEntryData } from '../../types/accounting/data/IEscrowJournalEntryData';
import { INewJournalEntryRequest } from '../../types/accounting/INewJournalEntryRequest';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const createJournalEntryAsync = async (
  journalEntry: INewJournalEntryRequest
): Promise<IEscrowJournalEntryData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IEscrowJournalEntryData>(`/timber/api/internal/escrow/journal_entries`, journalEntry)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
